import type { GraphQLFormattedError } from 'graphql'

const COMPANY_FROZEN_ERROR_CODE = 'COMPANY_FROZEN'

const listeners = new Set<() => void>()

export const isCompanyFrozenError = (error: GraphQLFormattedError) =>
  error.extensions?.code === COMPANY_FROZEN_ERROR_CODE

export const notifyCompanyFrozen = () => {
  listeners.forEach((listener) => listener())
}

export const subscribeToCompanyFrozen = (listener: () => void) => {
  listeners.add(listener)

  return () => {
    listeners.delete(listener)
  }
}
